import { SVGProps } from "react";

const XCloseCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    viewBox="0 0 25 25"
    {...props}
  >
    <g data-name="Group 19" transform="translate(-372 -18)">
      <circle
        cx={12.5}
        cy={12.5}
        r={12.5}
        fill="#d9d9d9"
        data-name="Ellipse 39"
        transform="translate(372 18)"
      />
      <path
        fill="none"
        stroke="#404040"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m384.5 30.502-4.316 4.317 4.316-4.317-4.316-4.318 4.316 4.318 4.317-4.318-4.317 4.318 4.317 4.317Z"
        data-name="Union 189"
      />
    </g>
  </svg>
);
export default XCloseCircle;
